import React from 'react';
import { MapPin } from 'lucide-react';
import { getInspectionLocationDisplay, getInspectionMapsUrl } from '@/utils/inspectionDisplay';

export default function InspectionLocationRow({ inspection, unavailableLabel }) {
  const text = getInspectionLocationDisplay(inspection, unavailableLabel);
  const mapsUrl = getInspectionMapsUrl(inspection);
  const isUnavailable = !text || text === unavailableLabel;

  return (
    <div className="flex items-center gap-2 text-gray-600">
      <MapPin className="w-4 h-4 shrink-0" />
      {mapsUrl && !isUnavailable ? (
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline break-words"
        >
          {text}
        </a>
      ) : (
        <span className="break-words">{text || unavailableLabel}</span>
      )}
    </div>
  );
}
